import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { AppDTO } from '@sb-tools/typescript/models/dto/app.dto';

@Injectable({ providedIn: 'root' })
export class AppsService {
    constructor(private httpClient: HttpClient) {}

    getApps(): Observable<AppDTO[]> {
        return this.httpClient.get<AppDTO[]>(environment.apiInboxUrl + 'apps');
    }

    updateStatus(appId: number, isActive: boolean): Observable<AppDTO> {
        return this.httpClient.patch<AppDTO>(environment.apiInboxUrl + `admin/apps/${appId}?isActive=${isActive}`, {});
    }
}
